"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const fourpaymentsbrand03 = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 67 67",
    "aria-labelledby": (title ? "title-fourpaymentsbrand03" : '') + (description ? " desc-fourpaymentsbrand03" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fourpaymentsbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fourpaymentsbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.429 12.643V40.07h27.428c0 15.149-12.28 27.429-27.428 27.429C17.28 67.5 5 55.22 5 40.071c0-15.148 12.28-27.428 27.429-27.428ZM39.57 5.5C54.72 5.5 67 17.78 67 32.929H39.571V5.5Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.571 1.5a1 1 0 0 1 1-1C51.272.5 64 13.228 64 28.929a1 1 0 0 1-1 1H35.571a1 1 0 0 1-1-1V1.5Zm2 1.019v25.41h25.41c-.513-13.801-11.609-24.897-25.41-25.41Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 36.071c0-15.7 12.728-28.428 28.429-28.428a1 1 0 0 1 1 1V35.07h26.428a1 1 0 0 1 1 1C56.857 51.772 44.13 64.5 28.43 64.5 12.728 64.5 0 51.772 0 36.071Zm27.429-26.41C13.296 10.187 2 21.811 2 36.071 2 50.667 13.832 62.5 28.429 62.5c14.26 0 25.884-11.296 26.41-25.429h-26.41a1 1 0 0 1-1-1V9.661Z"
  }))));
};
var _default = exports.default = fourpaymentsbrand03;